export default __webpack_public_path__ + "static/delaine-f018bd8e83dabf3ca0494d16915356d5.jpeg";